module.exports = __webpack_public_path__ + "static/media/frame_83.0fb1a7e8.jpg";